import React from 'react';
import { TableRow, TableCell, TableFooter } from 'semantic-ui-react';

import { WorksheetPageIndex } from 'services/worksheet/types';
import SumTanksEstimatedTableCell from './components/SumTanksEstimatedTableCell';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

type Props = OwnProps;

export default class PrintSprayWorksheetCompletionDetailsTableRow extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { pageIndex } = this.props;

        return (
            <TableFooter className="print-worksheet-footer-header">
                <TableRow>
                    <TableCell />
                    <TableCell />
                    <TableCell />
                    <SumTanksEstimatedTableCell pageIndex={pageIndex} />
                    <TableCell />
                    <TableCell />
                </TableRow>
            </TableFooter>
        );
    }
}
